import { useQuery } from 'react-query'

import { QUERY_KEYS } from 'src/constants'
import { accountsService } from 'src/services/accounts.service'

import { useParams } from 'react-router-dom'

const useGetAccountSubscriptionPlan = () => {
  const { accountId } = useParams()

  return useQuery(
    [QUERY_KEYS.ACCOUNT_SUBSCRIPTION_PLAN, accountId],
    async () => {
      return accountsService.getAccountSubscriptionPlan(accountId?.trim() || '')
    },
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      enabled: !!accountId,
    },
  )
}

export { useGetAccountSubscriptionPlan }
